import axios from "../../helpers/httpClient";

export default {
  requestServices: async ({ commit, state, dispatch }) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const service = await axios.get(`/information/private/management/getService`, {
        params: {} }, {
        headers: { 'Content-Type': 'application/json' }
      });

      // Stop Loader
      commit('SET_LOADER', false);

      if (service.status === 200) {
        const obj = {
          array: service.data.service,
          property: 'price'
        };

        let newStateData = await dispatch('updateAmountWithCurrency', obj);
        commit('SET_SERVICE', newStateData);
        commit('SET_SERVICE_FILTROS', newStateData);
      }

    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  },
  agregarServiceVuex: async ({ commit, state, dispatch }, payload) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const service = state.service
      const crearService = await axios.post("/information/private/management/addService", {
        ...payload,
      })

      // Stop Loader
      commit('SET_LOADER', false);

      if (crearService.status === 200) {
        service.push(crearService.data.data)

        commit('SET_SERVICE', service);
        commit('SET_SERVICE_FILTROS', service);

        dispatch('activeMessageCorrect', crearService.data.message)
        return 'ok'
      }
      return
    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  },
  editarServiceVuex: async ({ commit, state, dispatch }, payload) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const service = state.service
      const editarService = await axios.post("/information/private/management/editService", {
        ...payload,
      })

      // Stop Loader
      commit('SET_LOADER', false);

      if (editarService.status === 200) {
        service.forEach((data, index) => {
          if (data.id === editarService.data.data[0].id) {
            Object.assign(service[index], editarService.data.data[0])
          }
        })

        const obj = {
          array: service,
          property: 'price'
        };

        let newStateData = await dispatch('updateAmountWithCurrency', obj);

        commit('SET_SERVICE', newStateData);
        commit('SET_SERVICE_FILTROS', newStateData);

        dispatch('activeMessageCorrect', editarService.data.message)
        return 'ok'
      }
    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  },
  eliminarServiceVuex: async ({ commit, state, dispatch }, payload) => {
    try {
      // Start loader
      commit('SET_LOADER', true);

      const service = state.service
      const eliminarService = await axios.post("/information/private/management/deleteService", {
        ...payload,
      })

      // Stop Loader
      commit('SET_LOADER', false);

      if (eliminarService.status === 200) {
        const newService = service.filter((e) => e.id !== payload.id)

        commit('SET_SERVICE', newService);
        commit('SET_SERVICE_FILTROS', newService);

        dispatch('activeMessageCorrect', eliminarService.data.message)
      }

    } catch (error) {
      // Stop Loader
      commit('SET_LOADER', false);

      console.log(error)
      if (error?.response) {
        console.log(error?.response)
        dispatch('activeMessageError', (error.response !== undefined)
          ? error?.response?.data?.message || error?.response?.data?.msg
          : 'ERROR'
        )
      } else {
        dispatch('activeMessageError', 'ERROR')
        console.log(error)
      }
      return
    }
  }
}